import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../app/_guard/auth.guard';
import { DashboardComponent } from './Pages/dashboard/dashboard.component';
import { LoginComponent } from './Auth/login/login.component';
import { ChangePasswordComponent } from './Auth/change-password/change-password.component';
import { ProfileComponent } from './Pages/profile/profile.component';
import { UserListComponent } from './Pages/user-list/user-list.component';
import { StaticListComponent } from './Pages/static-list/static-list.component';
import { StaticEditComponent } from './Pages/static-edit/static-edit.component';
import { TransactionComponent } from './Pages/transaction/transaction.component';
import { MasterListComponent } from './Pages/master-list/master-list.component';
import { MasterCrudComponent } from './Pages/master-crud/master-crud.component';
import { ReportComponent } from './Pages/report/report.component';
import { UserDEtailComponent } from './Pages/user-detail/user-detail.component';
import { InqueryListComponent } from './Pages/inquery-list/inquery-list.component';
import { MasterCrudUpdateComponent } from './Pages/master-crud-update/master-crud-update.component';
import { FaqComponent } from './Pages/faq/faq.component';
import { FaqAddEditComponent } from './Pages/faq-add-edit/faq-add-edit.component';
import { RequestComponent } from './Pages/request/request.component';
import { DetailComponent } from './Pages/detail/detail.component';
import { CountryComponent } from './Pages/country/country.component';
import { AddCityComponent } from './Pages/add-city/add-city.component';
import { AppVersionComponent } from './Pages/app-version/app-version.component';


const routes: Routes = [
  { path:'',component:LoginComponent ,canActivate: [AuthGuard]},
  { path:'signin',component:LoginComponent ,canActivate: [AuthGuard]},
  { path:'dashboard',component:DashboardComponent  ,canActivate: [AuthGuard]},
  { path:'change-password',component:ChangePasswordComponent  ,canActivate: [AuthGuard]},
  { path:'profile',component:ProfileComponent ,canActivate: [AuthGuard] },
  { path:'static-page',component:StaticListComponent ,canActivate: [AuthGuard] }, 
  { path:'update-static',component:StaticEditComponent ,canActivate: [AuthGuard] },
  { path:'user-listing',component:UserListComponent ,canActivate: [AuthGuard] },
  { path:'user-detail',component:UserDEtailComponent ,canActivate: [AuthGuard] },
  { path:'transaction',component:TransactionComponent ,canActivate: [AuthGuard] }, 
  { path:'withdraw-transaction',component:TransactionComponent ,canActivate: [AuthGuard] }, 

  { path:'request',component:RequestComponent ,canActivate: [AuthGuard]},
  { path:'faq',component:FaqComponent ,canActivate: [AuthGuard]},
  { path:'faq-add',component:FaqAddEditComponent ,canActivate: [AuthGuard]},
  { path:'faq-update',component:FaqAddEditComponent ,canActivate: [AuthGuard]},

  { path:'interest',component:MasterListComponent ,canActivate: [AuthGuard]},
  { path:'add-interest',component:MasterCrudComponent ,canActivate: [AuthGuard]},
  { path:'update-interest',component:MasterCrudComponent ,canActivate: [AuthGuard]},
 
  { path:'report-user',component:ReportComponent ,canActivate: [AuthGuard]},
  { path:'report-post',component:ReportComponent ,canActivate: [AuthGuard]},
  { path:'report-comment',component:ReportComponent ,canActivate: [AuthGuard]},

  { path:'hair-type',component:MasterListComponent ,canActivate: [AuthGuard]},
  { path:'add-hair-type',component:MasterCrudComponent ,canActivate: [AuthGuard]},
  { path:'update-hair-type',component:MasterCrudComponent ,canActivate: [AuthGuard]},

  { path:'eye-type',component:MasterListComponent ,canActivate: [AuthGuard]},
  { path:'add-eye-type',component:MasterCrudComponent ,canActivate: [AuthGuard]},
  { path:'update-eye-type',component:MasterCrudComponent ,canActivate: [AuthGuard]},

  { path:'langugae',component:MasterListComponent ,canActivate: [AuthGuard]},
  { path:'update-langugae',component:MasterCrudComponent ,canActivate: [AuthGuard]},
  { path:'add-langugae',component:MasterCrudComponent ,canActivate: [AuthGuard]},

  { path:'category',component:MasterListComponent ,canActivate: [AuthGuard]},
  { path:'update-category',component:MasterCrudUpdateComponent ,canActivate: [AuthGuard]},

  { path:'body-type',component:MasterListComponent ,canActivate: [AuthGuard]},
  { path:'update-body-type',component:MasterCrudComponent ,canActivate: [AuthGuard]},
  { path:'add-body-type',component:MasterCrudComponent ,canActivate: [AuthGuard]},

  { path:'prefrence',component:MasterListComponent ,canActivate: [AuthGuard]},
  { path:'update-prefrence',component:MasterCrudComponent ,canActivate: [AuthGuard]},
  { path:'add-prefrence',component:MasterCrudComponent ,canActivate: [AuthGuard]},

  { path:'add-city',component:AddCityComponent ,canActivate: [AuthGuard]},
  { path:'country',component:CountryComponent ,canActivate: [AuthGuard]},
  { path:'city',component:CountryComponent ,canActivate: [AuthGuard]},

  { path:'app-version',component:AppVersionComponent ,canActivate: [AuthGuard]},


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
